import React, { useState } from "react";
import SecondaryButton from "./common/secondary-btn";
import PrimaryButton from "./common/primary-btn";

export default function ServiceTabs({ toggleModal }) {
  const seoServices = [
    {
      category: "Frontend",
      imgUrl: {
        techImg: [
          "https://glocify.com/images/angular.svg",
          "https://glocify.com/images/react.svg",
          "https://glocify.com/images/vuejs.svg",
          "https://glocify.com/images/javascript.svg",
          "https://glocify.com/images/css.svg",
          "https://glocify.com/images/html.svg"
        ]
      },
      techTitle: {
        techName: [
          "AngularJs",
          "ReactJS",
          "Vue.js",
          "JavaScript",
          "CSS3",
          "HTML5"
        ]
      }
    },
    {
      category: "Backend",
      imgUrl: {
        techImg: [
          "https://glocify.com/images/nodejs.svg",
          "https://glocify.com/images/php.svg",
          // "https://glocify.com/images/java.svg",
          // "https://glocify.com/images/phyton.svg",
          "https://glocify.com/images/nestjs.svg",
          "https://glocify.com/images/express.svg"
        ]
      },
      techTitle: {
        techName: ["Node.js", "PHP", "Nest.js", "Express"]
      }
    },
    {
      category: "Mobile",
      imgUrl: {
        techImg: [
          "https://glocify.com/images/ios.svg",
          "https://glocify.com/images/android-icon.svg",
          "https://glocify.com/images/swift.svg",
          "https://glocify.com/images/flutter.svg",
          "https://glocify.com/images/react-native.svg",
          // "https://glocify.com/images/xamarin.svg"
        ]
      },
      techTitle: {
        techName: [
          "iOS",
          "Android",
          "Swift",
          "Flutter",
          "React Native",
          // "Xamarin"
        ]
      }
    },
    {
      category: "Database",
      imgUrl: {
        techImg: [
          "https://glocify.com/images/mysql.svg",
          "https://glocify.com/images/postgresql.svg",
          // "https://glocify.com/images/sql-server.svg",
          "https://glocify.com/images/mongodb.svg",
          // "https://glocify.com/images/oracle.svg",
          "https://glocify.com/images/dynamodb.svg",
          "https://glocify.com/images/sqlite.svg",
          "https://glocify.com/images/firebase.svg"
        ]
      },
      techTitle: {
        techName: [
          "MySQL",
          "PostgreSQL",
          // "SQL Server",
          "MongoDB",
          // "Oracle",
          "DynamoDB",
          "SQLite",
          "Firebase"
        ]
      }
    },
    {
      category: "Framework",
      imgUrl: {
        techImg: [
          "https://glocify.com/images/laravel.svg",
          "https://glocify.com/images/codeigniter.svg",
          "https://glocify.com/images/mean.svg",
          "https://glocify.com/images/cake.svg",
          "https://glocify.com/images/nextjs.svg",
          "https://glocify.com/images/nestjs.svg"
        ]
      },
      techTitle: {
        techName: [
          "Laravel",
          "CodeIgniter",
          "MEAN",
          "CakePHP",
          "Next JS",
          "Nest JS",
          // "Django",
          // "Rxweb.io"
        ]
      }
    },
    {
      category: "Cloud",
      imgUrl: {
        techImg: [
          "https://glocify.com/images/google-cloud.svg",
          "https://glocify.com/images/aws.svg",
          "https://glocify.com/images/azure.svg"
        ]
      },
      techTitle: {
        techName: ["Google Cloud", "AWS", "Azure"]
      }
    },
    {
      category: "Ecommerce",
      imgUrl: {
        techImg: [
          "https://glocify.com/images/magento.svg",
          "https://glocify.com/images/shopify.svg",
          // "https://glocify.com/images/kentico.svg",
          "https://glocify.com/images/woocommerce.svg",
          // "https://glocify.com/images/woocommerce-io.svg"
        ]
      },
      techTitle: {
        techName: [
          "Magento",
          "Shopify",
          // "Kentico",
          "WooCommerce",
          // "WooCommerce.io"
        ]
      }
    }
  ];

  const [activeTab, setActiveTab] = useState("frontend");

  const handleTabClick = category => {
    setActiveTab(category);
  };

  return (
    <div className="lg:mt-10">
      <div className="lg:flex hidden border-b border-solid border-black/15 pt-[14px] pb-[18px] relative">
        {seoServices.map((service, index) =>
          <button
            key={index}
            className={`serviceTabs border-0 w-1/4 relative flex justify-center items-center text-base font-medium leading-5 tracking-tight cursor-pointe  ${activeTab ===
            service.category.toLowerCase().replace(/ /g, "")
              ? "active"
              : ""}`}
            onClick={() =>
              handleTabClick(service.category.toLowerCase().replace(/ /g, ""))}
          >
            <p data-title={service.category}>
              {service.category}
            </p>
          </button>
        )}
      </div>
      <div className="lg:hidden flex flex-nowrap w-full overflow-x-auto relative gap-4 mb-6">
        {seoServices.map((service, index) =>
          <button
            key={index}
            className={`mob-btn border-0 h-[32px] relative whitespace-nowrap bg-[#f2f2f2] p-[10px] w-full min-w-[95px] rounded-md text-black font-normal flex justify-center items-center text-sm overflow-hidden cursor-pointer  ${activeTab ===
            service.category.toLowerCase().replace(/ /g, "")
              ? "active"
              : ""}`}
            onClick={() =>
              handleTabClick(service.category.toLowerCase().replace(/ /g, ""))}
          >
            <p data-title={service.category}>
              {service.category}
            </p>
          </button>
        )}
      </div>

      <div className="wrapper_tabcontent">
        {seoServices.map((service, index) =>
          <div
            key={index}
            id={service.category.toLowerCase().replace(/ /g, "")}
            className={`tabcontent ${activeTab ===
            service.category.toLowerCase().replace(/ /g, "")
              ? "active"
              : ""}`}
          >
            <div className="flex gap-6 items-center flex-wrap justify-center">
              {service.imgUrl.techImg.map((img, imgIndex) =>
                <div
                  key={imgIndex}
                  className="bg-[#F6F6F6] border-border-solid border-[#F6F6F6] w-[165px] min-w-[165px] h-[165px] flex items-center flex-col justify-center gap-6"
                >
                  <img src={img} alt={service.techTitle.techName[imgIndex]} />
                  <h4 className="text-sm font-medium leading-5 tracking-tight uppercase text-black">
                    {service.techTitle.techName[imgIndex]}
                  </h4>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
